


export const AssetUriMap = {
    itemsAvailable: 'https://storage.googleapis.com/finiat-web-static-resources/platformIcons/user-available.png',
    total: 'https://storage.googleapis.com/finiat-web-static-resources/platformIcons/total-icon.png',
    selectedItems: 'https://storage.googleapis.com/finiat-web-static-resources/platformIcons/selected-items.png'

}

export const finishUrl = (url)=>{
    if (url.startsWith('/img/logo')){
        return `https://eodhistoricaldata.com${url}`
    }
    return url
}